/**
 * Converts an object of parameters into a URL query string
 * @param params Object containing key-value pairs to convert to query string
 * @returns Formatted query string
 */
const queryString = (params: Record<string, any>): string =>
  Object.keys(params)
    .map(key => {
      if (Array.isArray(params[key])) {
        return params[key]
          .map(
            (value: any) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join('&')
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    })
    .join('&')

export default queryString
